(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('PacketRuleConfirmController', PacketRuleConfirmController);

    PacketRuleConfirmController.$inject = ['$scope', '$uibModalInstance', 'PacketRuleService', 'packetRuleItem', 'dataAction'];

    function PacketRuleConfirmController($scope, $uibModalInstance, PacketRuleService, packetRuleItem, dataAction) {
        var vm = this;
        vm.requestRunning = false;


        if (dataAction) {
            vm.action = dataAction.action;
            vm.packetRuleData = packetRuleItem[0];
            vm.itemOne = true;

            vm.close = function () {
                if (!vm.requestRunning) {
                    $uibModalInstance.dismiss('cancel');
                }
            }

            vm.confirmAction = function () {
                vm.requestRunning = true;
                PacketRuleService[dataAction.methodService](vm.packetRuleData).then(success).catch(error);
            }
        }
        function success() {
            vm.requestRunning = false;
            var isMultiple = !vm.itemOne;

            PacketRuleService.successModalConstructor(vm.action, isMultiple);
            if (dataAction.methodExtra) {
                dataAction.methodExtra(packetRuleItem);
            }
        }

        function error(response) {
            vm.requestRunning = false;
            PacketRuleService.errorModalConstructor(response, vm.action);
        }

    }
})();